import { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import "../../css/ListUsers.css";
import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";
import CommodityReadOnlyRow from "../../components/CommodityReadOnlyRow";
import CommodityTableRow from "../../components/CommodityTableRow";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import ProductFilter from "./ProductFilter";
import { useTranslation } from 'react-i18next';


function ListCommodities() {
	const navigate = useNavigate();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);

	const [edit, setEdit] = useState(false);
	const [errorValue, setErrorValue] = useState("");
	const [keyword, setKeyword] = useState("");
	const [productGroupKey, setProductGroupKey] = useState(0);
	const [productGroupName, setProductGroupName] = useState("");
	const [commodityList, setCommodityList] = useState([]);
	const [editableRecord, setEditableRecord] = useState({});
	const [count, setCount] = useState(0);
	const { t } = useTranslation();
	const userCtx = useContext(UserContext);

	const [isLoading, setIsLoading] = useState(false);
	useEffect(() => {
	}, []);

	const initialValues = {
		productGroupKey: 0,
		commodityKey: 0,
		commodityName: "",
		description: "",
		updatedById: userCtx.loggedInUserId,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	const onClickFilterCallback = (searchFilter, selectedProductGroupKey, selectedProductGroupName) => {
		if (searchFilter === keyword && productGroupKey === selectedProductGroupKey) {
			return
		}
		setKeyword(searchFilter);
		setProductGroupKey(selectedProductGroupKey);
		setProductGroupName(selectedProductGroupName);
		setFormValues({ ...formValues, ["productGroupKey"]: selectedProductGroupKey });
		fetchCommodity(searchFilter, selectedProductGroupKey);
	}
	function fetchCommodity(searchFilter, selectedProductGroupKey) {
		setErrorValue("");
		setIsLoading(true);
		resetCounter();
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: true, searchValue: searchFilter, productGroupKey: selectedProductGroupKey }),
		};
		try {
			FetchUtil.fetchAPI("MGetCommodity", "/Service/StaticHelper/GetCommodity", requestOptions, getCommoditySuccess, getCommodityFail);
		} catch (error) {
			setIsLoading(false);
			setErrorValue(error.message);
		}
	}

	function getCommodityFail(redirect) {
		setIsLoading(false);
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.getProdFailed"));
	}
	function getCommoditySuccess(responseData) {
		let getCommodityResponse;
		if (responseData) {
			getCommodityResponse = responseData.getCommodityResponse;
			if (getCommodityResponse && getCommodityResponse.errorCode === "0") {
				setCommodityList([...getCommodityResponse.commodityList]);
			} else if (getCommodityResponse && getCommodityResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getCommodityResponse) {
				setErrorValue(t("error.error") + " " + getCommodityResponse.errorMessage);
			}
		}
		setIsLoading(false);
	}

	const handleDeleteClick = (event, commodityListItem, completeCallback) => {
		event.preventDefault();
		deleteCommodity(commodityListItem, completeCallback);
	};
	const deleteCommodity = (commodityListItem, completeCallback) => {
		let action = 3;
		if (commodityListItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			commodityKey: commodityListItem.commodityKey,
			statusCode: commodityListItem.statusCode,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteCommodity", "/Service/StaticHelper/DeleteCommodity", requestOptions, deleteCommoditySuccess, deleteCommodityFail, completeCallback);
		} catch (error) {
			setErrorValue(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteCommodityFail(redirect, completeCallback) {
		setErrorValue(t("error.commoEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteCommoditySuccess(responseData, completeCallback) {
		let deleteCommodityResponse;
		if (responseData) {
			deleteCommodityResponse = responseData.deleteCommodityResponse;
			if (deleteCommodityResponse) {
				if (deleteCommodityResponse.errorCode === "0") {
					resetRowTable();
					fetchCommodity(keyword, productGroupKey);
				} else if (deleteCommodityResponse && deleteCommodityResponse.errorCode === "114") {
					navigate("/", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				} else {
					setErrorValue(t("error.error") + " " +
						deleteCommodityResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setErrorValue("");
		if (!add && !edit) {
			setAdd(true);
		} else {
			if (add) {
				setErrorValue(t("error.only1RowAllowed"));
			} else if (edit) {
				setErrorValue(t("error.onlyEditAllowed"));
			}
		}
	};
	const removeRowTable = () => {
		setErrorValue("");
		resetRowTable();
		setIsLoading(false);
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
		setEdit(false);
	};
	const handleEditClick = (event, commodityItem, completeCallback) => {
		event.preventDefault();
		setErrorValue("");
		if (!add && !edit) {
			setEdit(true);
			setEditableRecord(commodityItem);
		} else {
			if (add) {
				setErrorValue(t("error.newRowAdded"));
			} else if (edit) {
				setErrorValue(t("error.onlyEditAllowed"));
			}
		}
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setErrorValue("");
		let found = false;
		if (!formValues.productGroupKey) {
			setErrorValue(t("error.prodGrp.Reqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (commodityList.length > 0) {
				commodityList.map((commodityListItem, index) => {
					if (commodityListItem.commodityName === setValues.commodityName) {
						setErrorValue(t("error.prodDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveCommodity(action, setValues, completeCallback);
			}
		} else if (action === 2) {
			if (!setValues.commodityKey) {
				setErrorValue(t("error.commodityKey.Reqd"));
				if (completeCallback) {
					completeCallback();
				}
				return false;
			}
			if (commodityList.length > 0) {
				commodityList.map((commodityListItem, index) => {
					if (commodityListItem.commodityName === setValues.commodityName) {
						if (commodityListItem.commodityKey !== setValues.commodityKey) {
							setErrorValue(t("error.prodDup"));
							found = true;
							if (completeCallback) {
								completeCallback();
							}
							return false;
						} else if (commodityListItem.commodityKey === setValues.commodityKey &&
							commodityListItem.description === setValues.description) {
							found = true;
							if (completeCallback) {
								completeCallback();
							}
							return false;
						}
					}
				})
			}
			if (!found) {
				saveCommodity(action, setValues, completeCallback);
			}
		}
	};
	const saveCommodity = (action, setValues, completeCallback) => {
		let serverParams = {
			productGroupKey: formValues.productGroupKey,
			commodityKey: setValues.commodityKey,
			commodityName: setValues.commodityName,
			description: setValues.description,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateCommodity", "/Service/StaticHelper/AddUpdateCommodity", requestOptions, saveCommoditySuccess, saveCommodityFail, completeCallback);
		} catch (error) {
			setErrorValue(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveCommodityFail(redirect, completeCallback) {
		setErrorValue(t("error.commoEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveCommoditySuccess(responseData, completeCallback) {
		let addUpdateCommodityResponse;
		if (responseData) {
			addUpdateCommodityResponse = responseData.addUpdateCommodityResponse;
			if (addUpdateCommodityResponse) {
				if (addUpdateCommodityResponse.errorCode === "0") {
					resetRowTable();
					fetchCommodity(keyword, productGroupKey);
				} else if (addUpdateCommodityResponse.errorCode === "114") {
					navigate("/", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				} else {
					setErrorValue(t("error.error") + " " +
						addUpdateCommodityResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	return (
		<div className="container-fluid">
			<Header />
			<div className={"container-fluid container_list viewh-85"}>
				{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
					<>
						<div className="row">
							<div className="col">
								<div
									id="inerrorMessage"
									className={
										(errorValue) ? "errorblock" : "errorblock hide"
									}
								>
									{errorValue ? errorValue : ""}
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<div id="placeholder_1" className="placeholder-pg"></div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<ProductFilter t={t} setErrorValue={setErrorValue} onClickFilterCallback={onClickFilterCallback}
									defaultKeyword={keyword} defaultGroupKey={productGroupKey} />
							</div>
							{(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
						</div>
						<div className="row">
							<div className="col">
								<div id="placeholder_2" className="placeholder-pg"></div>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<table className="list-table" role="table">
									<thead>
										<tr role="row">
											<th className="list-th">{t("page.productGrp")}</th>
											<th className="list-th">{t("page.commodity")}</th>
											<th className="list-th">{t("page.description")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "9vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</thead>
									<tbody role="rowgroup">
										{add && addRowTop &&
											<CommodityTableRow
												index={count}
												productGroupName={productGroupName}
												commodityListItem={{}}
												handleSubmit={handleSubmit}
												setError={setErrorValue}
												t={t}
												setAdd={setAdd}
												setEdit={setEdit}
												oddIdx={((commodityList.length % 2) > 0) ? true : false} />
										}
										{(commodityList.length > 0) ? (
											commodityList.map((commodityListItem, index) => (
												((edit && commodityListItem.commodityKey === editableRecord.commodityKey) ?
													<CommodityTableRow
														index={count}
														productGroupName={productGroupName}
														commodityListItem={commodityListItem}
														handleSubmit={handleSubmit}
														setError={setErrorValue}
														t={t}
														setAdd={setAdd}
														setEdit={setEdit}
														oddIdx={((commodityList.length % 2) > 0) ? true : false} />
													:
													<CommodityReadOnlyRow
														index={count}
														t={t}
														commodityListItem={commodityListItem}
														handleDeleteClick={handleDeleteClick}
														handleEditClick={handleEditClick}
														oddIdx={((index % 2) > 0) ? true : false}
														add={add}
														setError={setErrorValue}
													/>
												)
											))
										) : (<></>)}

										{add && addRowBottom &&
											<CommodityTableRow
												index={count}
												productGroupName={productGroupName}
												commodityListItem={{}}
												handleSubmit={handleSubmit}
												setError={setErrorValue}
												t={t}
												setAdd={setAdd}
												setEdit={setEdit}
												oddIdx={((commodityList.length % 2) > 0) ? true : false} />
										}
									</tbody>
									{(commodityList.length > 10) ? (<tfoot>
										<tr role="row">
											<th className="list-th">{t("page.productGrp")}</th>
											<th className="list-th">{t("page.commodity")}</th>
											<th className="list-th">{t("page.description")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "9vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</tfoot>
									) : (<></>)}
								</table>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div
									id="berrorMessage"
									className={
										(errorValue) ? "errorblock" : "errorblock hide"
									}
								>
									{errorValue ? errorValue : ""}
								</div>
							</div>
						</div>
					</>
					: null}
			</div>
			<div className="footer_container">
				<Footer />
			</div>
		</div>
	);
}

export default ListCommodities;